<template>
  <div class="container">
    <p>
      用户按照需要输入检索问题，系统会根据语义分析精准分析用户检索问题，智能寻找知识库中匹配文章。
    </p>
    <img src="../../assets/images/newhelp/help6.png" alt="" />
    <p>
      系统自动分析数据库里的文章的摘要，从摘要中提取与检索内容相关的文献资源，提供相关度最高的资源呈现给读者并精短阐述相关，并且把每个知识点的出处链接提供给读者方便查找原文章。同时下方有多轮对话框可以根据问题进行相关问题搜索
    </p>
    <img src="../../assets/images/newhelp/help32.png" alt="" />
  </div>
</template>
<script>
export default {
  name: "Page1",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.container {
  padding: 75px;
  p,
  img {
    margin-bottom: 15px;
    font-size: 18px;
    max-width: 100%;
  }
  .red {
    color: #fa0000;
  }
}
</style>
